import { createUseStyles } from 'react-jss'
import { WHITE_23, WHITE, BLUE, BLUE_25, DARK_GRAY_11 } from '@omnilert/components'

export default createUseStyles({
  '@keyframes suggestionReplySpin': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' }
  },
  suggestion: {
    alignItems: 'center',
    backgroundColor: BLUE,
    border: 'none',
    borderRadius: 20,
    boxShadow: () => [
      `0px 4px 15px ${BLUE_25}`,
      `0px 2px 4px ${DARK_GRAY_11}`,
      `inset 0px -2px 0px ${WHITE_23}`
    ],
    cursor: 'pointer',
    display: 'inline-flex',
    gap: 8,
    marginRight: 10,
    maxWidth: '300px',
    padding: '10px 20px',
    textAlign: 'left',
    transition: 'opacity 120ms ease, transform 120ms ease',
    '&:disabled': {
      cursor: 'default'
    }
  },
  pressed: {
    /* The user has tapped this suggestion; a saga is sending and we're
     * waiting on the Firestore round-trip. Give a clear visual cue
     * (slight depress + spinner) so the tap is unmistakably registered. */
    boxShadow: 'none',
    cursor: 'default',
    opacity: 0.85,
    transform: 'translateY(1px)'
  },
  disabled: {
    /* Other suggestions in the same group while one is pressed. Greyed
     * to communicate "you can't pick a different answer right now". */
    cursor: 'default',
    opacity: 0.5
  },
  spinner: {
    animation: '$suggestionReplySpin 800ms linear infinite',
    border: `2px solid ${WHITE_23}`,
    borderRadius: '50%',
    borderTopColor: WHITE,
    display: 'inline-block',
    height: 12,
    width: 12
  },
  text: {
    color: WHITE,
    fontSize: 14,
    letterSpacing: '-0.02em',
    fontFamily: 'BentonSansMedium'
  }
})
